import type { GenerateFlyerRequest } from '@pulsify/shared/dto'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { flyerApi } from '../api'

interface FlyerVars {
  file: File | null
  params: GenerateFlyerRequest
}

export function useGenerateFlyer(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ file, params }: FlyerVars) => flyerApi.generate(businessId, file, params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.CREDITS_BALANCE, businessId),
      })
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.GENERATED_ASSETS, businessId),
      })
    },
  })
}
